import React from 'react';

const ResetPassword = () => {
  return (
    <div>
      <h1>Reset Password</h1>
    </div>
  );
};

export default ResetPassword;
